import type { WorkingHoursResponse } from '@/libs/interfaces'

import { MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

/** Mon-Fri 08:00-17:00 opening hours per seed.ts store, with no special hours. */

const standardWeekdayHours = {
  mondayOpen: '08:00',
  mondayClose: '17:00',
  tuesdayOpen: '08:00',
  tuesdayClose: '17:00',
  wednesdayOpen: '08:00',
  wednesdayClose: '17:00',
  thursdayOpen: '08:00',
  thursdayClose: '17:00',
  fridayOpen: '08:00',
  fridayClose: '17:00',
  saturdayOpen: '',
  saturdayClose: '',
  sundayOpen: '',
  sundayClose: '',
}

export const mockWorkingHours: WorkingHoursResponse[] = [
  {
    storeID: MOCK_STORE_ID_1,
    weekyOpeningHours: standardWeekdayHours,
    specialHours: [],
  },
  {
    storeID: MOCK_STORE_ID_2,
    weekyOpeningHours: standardWeekdayHours,
    specialHours: [],
  },
]
